export class KYMW0909OutputModel {
  // モード
  public mode: number = null;

  // アイテムコード
  public selectedItemCode = '';

  // アイテムコードリスト
  public itemCodeList = [];

  // 注文コード割当コード
  public pointExchangeOrderNumQuotaCode = '';

  // 注文コード割当リスト
  public pointExchangeOrderNumQuotaCodeList = [];

  // ポイント交換注文コード
  public pointExchangeOrderNum = '';

  // 専用商品名
  public pointExchangeGoodsName = '';

  // 専用商品名(カナ)
  public pointExchangeGoodsNameKana = '';

  // 専用規格名
  public pointExchangeGuideName = '';

  // 専用規格名(カナ)
  public pointExchangeGuideNameKana = '';

  // ポイント不足エラー区分
  public shortOfPointDiv = '';

  // ECのみフラグ
  public ecOnlyFlg = '';

  // 消費税率
  public consumeTaxRate: number = <number>0;
  
  // ポイント購入時割引率一括設定値
  public pointRateAllSetting: string = <string>'';

  // 会員生協別ポイント一覧
  public coopPointRateList: Array<any> = new Array<any>();

  // 追加フラグ
  public registFlg = '0';

  // 削除フラグ
  public deleteFlg = '0';
}
